import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { buildContentListItemStylesheet } from "../elements/ElementListStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";
library.add(fab, fas, far);

const ContentListItem = (props) => {
  let list_item = props.list_item;
  let element = props.element;

  function numberToLetter(n) {
    let result = "";
    while (n > 0) {
      let remainder = (n - 1) % 26;
      result = String.fromCharCode(65 + remainder) + result;
      n = Math.floor((n - remainder) / 26);
    }
    return result;
  }

  const visualType =
    list_item.visual_type ||
    element.options.list_visual_type ||
    props.variant.options.list_visual_type ||
    "bullet";

  const classes = style.classes(list_item);
  const stylesheet = buildContentListItemStylesheet(
    props.builder,
    props.device,
    props.cta,
    list_item,
    element,
    props.variant,
    visualType
  );

  const visualTypeValue = () => {
    if (visualType === "image") {
      return (
        list_item.image ||
        element.options.list_image ||
        props.variant.options.list_image
      );
    } else if (visualType === "letter") {
      return list_item.letter || numberToLetter(parseInt(list_item.position));
    } else if (visualType === "icon") {
      return (
        list_item.icon ||
        element.options.list_icon ||
        props.variant.options.list_icon
      );
    } else if (visualType === "emoji") {
      return (
        list_item.emoji ||
        element.options.list_emoji ||
        props.variant.options.list_emoji
      );
    }
  };

  const isBulletVisualType = () => {
    return visualType === "bullet";
  };

  const isImageVisualType = () => {
    return visualType === "image" && visualTypeValue();
  };

  const isLetterVisualType = () => {
    return visualType === "letter" && visualTypeValue();
  };

  const isIconVisualType = () => {
    return visualType === "icon" && visualTypeValue();
  };

  const isEmojiVisualType = () => {
    return visualType === "emoji" && visualTypeValue();
  };

  const isNumberedVisualType = () => {
    return visualType === "numbered";
  };

  const visualTypeBlock = () => {
    return (
      <React.Fragment>
        {isImageVisualType() ? (
          <span
            className={"cf-image-visual-type"}
            style={{ marginRight: "10px", marginLeft: "10px" }}
          >
            <img src={visualTypeValue()}></img>
          </span>
        ) : (
          <div className="cf-visual-type">
            {isBulletVisualType() ? (
              <span className={"cf-visual-type-bullet"}>•</span>
            ) : (
              ""
            )}
            {isIconVisualType() ? (
              <span className={"cf-visual-type-icon"}>
                <FontAwesomeIcon icon={visualTypeValue()} />
              </span>
            ) : (
              ""
            )}

            {isEmojiVisualType() ? (
              <span className={"cf-visual-type-emoji"}>
                {visualTypeValue()}
              </span>
            ) : (
              ""
            )}

            {isLetterVisualType() ? (
              <span className={"cf-visual-type-letter"}>
                {visualTypeValue()}
              </span>
            ) : (
              ""
            )}

            {isNumberedVisualType() ? (
              <span className={"cf-visual-type-numbered"}>
                {list_item.position}
              </span>
            ) : (
              ""
            )}
          </div>
        )}
      </React.Fragment>
    );
  };

  useEffect(() => {
    let element_tag = document.querySelector(
      '#builder .cf-element[data-element-id="' + element.id + '"]'
    );
    if (!element_tag) return;

    let list_item_froala = element_tag.querySelector(
      `#list-item-${list_item.id} .cf-content`
    );
    if (!list_item_froala) return;

    $(list_item_froala)
      .off("click")
      .on("click", function (e) {
        let item_list_trigger = document.querySelector(
          `.item-trigger[data-object_type="content_list_items"][data-object_id="${list_item.id}"]`
        );

        if (item_list_trigger) {
          item_list_trigger.click();
        }
      });
  }, []);

  return (
    <React.Fragment>
      <li
        id={`list-item-${list_item.id}`}
        className={classes}
        key={"item-" + list_item.id}
        data-emoji={isEmojiVisualType() ? list_item.emoji : ""}
      >
        {visualTypeBlock()}
        <div
          className="cf-content"
          style={{ display: "inline-block" }}
          dangerouslySetInnerHTML={{
            __html: list_item.content,
          }}
        ></div>
      </li>
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:list-item:${list_item.id}`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

const style = {
  classes: (list_item) => {
    let options = list_item.options;
    let classes = "element-content cf-list-element-item cf-merge-tag-allowed";

    return classes;
  }
};

export default ContentListItem;
